import { Component } from "react";
import { reportClientError } from "../../api/alerts";

// Catches a screen that fails to render, reports it (so you get a
// "something broke" alert), and shows a way out instead of a blank page.
// On the pay page the quote token goes along, which is what lets the
// server accept a report from a customer's browser.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const path = window.location.pathname;
    const token = path.startsWith("/pay/") ? path.split("/")[2] : undefined;
    reportClientError({ where: path.replace(/\/pay\/[^/]+/, "/pay"), message: error?.message || String(error), token });
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    const onPayPage = window.location.pathname.startsWith("/pay/");
    return (
      <div className="min-h-screen bg-birdie-beige flex items-center justify-center p-6">
        <div className="max-w-sm w-full bg-white border border-birdie-green/15 rounded-2xl p-6 text-center">
          <div className="text-3xl mb-2">😕</div>
          <h1 className="font-semibold text-birdie-charcoal">Something went wrong on this page</h1>
          <p className="text-sm text-birdie-charcoal/65 mt-2">
            {onPayPage
              ? "Please reload. If it keeps happening, reply to your quote email and we'll sort it out."
              : "We've been notified. Reloading usually fixes it."}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 w-full bg-birdie-green text-white font-semibold rounded-xl px-4 py-3"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
